import { render, staticRenderFns } from "./ModalEmitirRelatorioTabelaPropria.vue?vue&type=template&id=48e15fb8"
import script from "./ModalEmitirRelatorioTabelaPropria.vue?vue&type=script&lang=ts"
export * from "./ModalEmitirRelatorioTabelaPropria.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports